"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.ButtonContainer = ({ children, noMargin, }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: [!noMargin && 'ml-2'], flexColCentered: true }, children));
};
//# sourceMappingURL=ButtonContainer.js.map